import React, { Component } from "react";
import { Row, Col, Container, Button } from "react-bootstrap";
import { Popover, Skeleton, Modal } from "antd";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { TiDeleteOutline } from "react-icons/ti";
import $ from 'jquery';
import boate from "../../../images/boat/boate.jpg";
import { DataContext } from "../BoatStore/BoatData";
import { RiArrowLeftDownLine, RiArrowRightUpLine } from "react-icons/ri";
import Reviews from "./Review";
import ReactStars from "react-rating-stars-component";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import {
  IoIosArrowDropright,
  IoIosArrowDropleft,
  IoMdClose,
} from "react-icons/io";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaLastfmSquare } from "react-icons/fa";
import { validateProperty } from "../../Validation/JoiValidation";
import { Input } from "../../common/forms/Input";
import { Form } from "informed";

class BoatListCard extends Component {
  static contextType = DataContext;
  constructor(props) {
    super(props);
    this.state = {
      selected: 'item1',
      openPersonAlert: false,
      showErrorMsg:false,
      openSubmitAlert: true,
      IsBoathouse:this.props.IsBoathouse,
      
    }
  }



  setFormApi = (formApi) => (this.formApi = formApi);


  showErrorImg = async (ev) => {
    ev.target.src = boate;
  };

  showPersonAlert = () =>{
    this.setState({ openPersonAlert: true })
  }
  // handleButtonClick = (boat,type) => {
  //   this.setState({ boat: boat,type:type })
  //   if(this.state.openSubmitAlert && !this.context.state.checkType && this.context.state.EntranceList?.length > 0){
  //     this.showPersonAlert()
  //   }else{
  //     this.context.SelectTimeSlot(boat, type)
  //   }
    
  // }
  // handleSubmit = () => {
  //   const values = this.formApi.getValues();
  //   const isIntegerNonZero = (str) => {
  //         const num = Number(str);
  //         return Number.isInteger(num) && num.toString() === str && num !== 0;
  //       };
  //     const hasNonZeroValue = Object.values(values).some(value => isIntegerNonZero(value));
  // if (values.Adult === "0") {
  //     console.log("Adult value is 0");
  //     this.setState({ openPersonAlert: true, showErrorMsg: true });
  // } else if (hasNonZeroValue) {
  //     console.log("At least one value must be a valid non-zero integer");
  //     this.setState({ openPersonAlert: false, showErrorMsg: false, openSubmitAlert: false });
  //     this.context.SelectTimeSlot(this.state.boat, this.state.type, values, true);
  // } else {
  //     console.log("All values are either not integers or are 0");
  //     this.setState({ openPersonAlert: true, showErrorMsg: true });
  // } 
  // }
  

  getNormalTicket = (boat, type) => {
    return (
      
      <Col md={2} className={`normalticketdiv `}>
        {this.context.state.type === "I" && this.context.state.selectedid.some((boatcart) => boatcart.boatid === boat.boatid) && <div className={(boat.Normal === "Y" && (boat.Individual === "N"|| boat.Individual === "" || boat.Individual === null || boat.Individual === undefined ) && (boat.Express === "N" || boat.Express === "" || boat.Express === null || boat.Express === undefined)) ? "selected-div-new" : "selected-div"}></div>}

        <>
          <div className="ntitle">Normal Boat</div>
          <div className="small-div">(Per Ticket)</div>
          <div className="mt-2"> ₹ {parseInt(parseFloat(boat.NTBoatTotalCharge || 0) + parseFloat(boat.NTdepositeCharge || 0))}</div>
          <div className="boaatcharge ">
            <table>
              {boat.NTdepositeCharge != "0.00" ? (
                <tr>
                  <td>Boat</td>
                  <td>:</td>
                  <td> ₹ {parseInt(boat.NTBoatTotalCharge || 0)}</td>
                </tr>
              ) : (
                ""
              )}
              {boat.NTdepositeCharge != "0.00" ? (
                <tr>
                  <td>
                    <Popover
                      content={
                        <>
                          Charge includes Refundable Deposit of ₹ <b>{parseInt(boat.NTdepositeCharge || 0)}</b>
                        </>
                      }
                    >
                      <span className="depspan">Deposit</span>
                    </Popover>
                  </td>
                  <td>:</td>
                  <td> ₹ {parseInt(boat.NTdepositeCharge || 0)}</td>
                </tr>
              ) : (
                ""
              )}
            </table>
          </div>
          {console.log(this.context.state.type === "I")}
          {this.context.state.type === "I" && this.context.state.selectedid.some((boatcart) => boatcart.boatid === boat.boatid) ? (
            
            <div className="mt-1" onClick={() => this.context.HideTimeSlot(boat, "I")}>
              <span>
                <Button className={(boat.Normal === "Y" && (boat.Individual === "N"|| boat.Individual === "" || boat.Individual === null || boat.Individual === undefined ) && (boat.Express === "N" || boat.Express === "" || boat.Express === null || boat.Express === undefined)) ? "btn expboatcolor btn-sm exbtn-new" : "btn expboatcolor btn-sm exbtn"}>Hide Time Slot</Button>
              </span>
            </div>
          ) : (
            
            <div className="mt-1" 
              onClick={() => this.context.SelectTimeSlot(boat, "I")}
              // onClick={() => this.handleButtonClick(boat,"I")}
            >
              <span>
                <Button className={(boat.Normal === "Y" && (boat.Individual === "N"|| boat.Individual === "" || boat.Individual === null || boat.Individual === undefined ) && (boat.Express === "N" || boat.Express === "" || boat.Express === null || boat.Express === undefined)) ? "btn expboatcolor btn-sm exbtn-new" : "btn expboatcolor btn-sm exbtn"}>Select Time Slot</Button>
              </span>
            </div>
          )}

          {this.context.state.type === "I" && this.context.state.selectedid.some((boatcart) => boatcart.boatid === boat.boatid) && <div className={(boat.Normal === "Y" && (boat.Individual === "N"|| boat.Individual === "" || boat.Individual === null || boat.Individual === undefined ) && (boat.Express === "N" || boat.Express === "" || boat.Express === null || boat.Express === undefined)) ? "rectangle-new" : "rectangle"}></div>}
        </>
      </Col>
    );
  };
  getNormalBoat = (boat, type) => {

    return (
      <Col md={2} className={ (boat.Normal === "Y" && (boat.Individual === "N"|| boat.Individual === "" || boat.Individual === null || boat.Individual === undefined ) && (boat.Express === "N" || boat.Express === "" || boat.Express === null || boat.Express === undefined)) ? "normaldiv-new" : "normaldiv"}>
        {this.context.state.type === "N" && this.context.state.selectedid.some((boatcart) => boatcart.boatid === boat.boatid) && <div className={(boat.Normal === "Y" && (boat.Individual === "N"|| boat.Individual === "" || boat.Individual === null || boat.Individual === undefined ) && (boat.Express === "N" || boat.Express === "" || boat.Express === null || boat.Express === undefined)) ? "selected-div-new" : "selected-div"}></div>}

        <>
          <div className="ntitle">{this.props.IsBoathouse ? "Normal Boat" : "Booking"}</div>
          <div className="small-div"> {this.props.IsBoathouse ? "(Per Boat)" : "(Per Slot)"}</div>
          <div className="mt-2"> ₹ {parseInt(parseFloat(boat.BoatTotalCharge || 0) + parseFloat(boat.NBdepositeCharge || 0))}</div>
          <div className="boaatcharge ">
            {" "}
            <table>
              {boat.NBdepositeCharge != "0.00" ? (
                <tr>
                  <td>Boat</td>
                  <td>:</td>
                  <td> ₹ {parseInt(boat.BoatTotalCharge || 0)}</td>
                </tr>
              ) : (
                ""
              )}
              {boat.NBdepositeCharge != "0.00" ? (
                <tr>
                  <td>
                    <Popover
                      content={
                        <>
                          Charge includes Refundable Deposit of ₹ <b>{parseInt(boat.NBdepositeCharge || 0)}</b>
                        </>
                      }
                    >
                      <span className="depspan">Deposit</span>
                    </Popover>
                  </td>
                  <td>:</td>
                  <td> ₹ {parseInt(boat.NBdepositeCharge || 0)}</td>
                </tr>
              ) : (
                ""
              )}
            </table>
          </div>

          {this.context.state.type === "N" && this.context.state.selectedid.some((boatcart) => boatcart.boatid === boat.boatid) ? (
            <div className="mt-3" onClick={() => this.context.HideTimeSlot(boat, "N")}>
              <span>
                <Button className={ (boat.Normal === "Y" && (boat.Individual === "N"|| boat.Individual === "" || boat.Individual === null || boat.Individual === undefined ) && (boat.Express === "N" || boat.Express === "" || boat.Express === null || boat.Express === undefined)) ? "btn btn-success btn-sm  exbtn-new" : "btn btn-success btn-sm  exbtn"}>Hide Time Slot</Button>
              </span>
            </div>
          ) : (
            <div className="mt-3" 
                onClick={() => this.context.SelectTimeSlot(boat, "N")}

                // onClick={() => this.handleButtonClick(boat,"N")}
            >
              <span>
                {console.log("Select Time Slot",boat)}
                <Button className={ (boat.Normal === "Y" && (boat.Individual === "N"|| boat.Individual === "" || boat.Individual === null || boat.Individual === undefined ) && (boat.Express === "N" || boat.Express === "" || boat.Express === null || boat.Express === undefined)) ? "btn btn-success btn-sm  exbtn-new" : "btn btn-success btn-sm  exbtn"}>Select Time Slot</Button>
              </span>
            </div>
          )}
          {this.context.state.type === "N" && this.context.state.selectedid.some((boatcart) => boatcart.boatid === boat.boatid) && <div className={(boat.Normal === "Y" && (boat.Individual === "N"|| boat.Individual === "" || boat.Individual === null || boat.Individual === undefined ) && (boat.Express === "N" || boat.Express === "" || boat.Express === null || boat.Express === undefined)) ? "rectangle-new" : "rectangle"}></div>}
        </>
      </Col>
    );
  };
  getExpressBoat = (boat, type) => {
    return (
      <Col md={2} className="expressssdiv">
        {this.context.state.type === "P" && this.context.state.selectedid.some((boatcart) => boatcart.boatid === boat.boatid) && <div className={(boat.Normal === "Y" && (boat.Individual === "N"|| boat.Individual === "" || boat.Individual === null || boat.Individual === undefined ) && (boat.Express === "N" || boat.Express === "" || boat.Express === null || boat.Express === undefined)) ? "selected-div-new" : "selected-div"}></div>}

        <>
          <div className="etitle">Express Boat</div>
          <div className="small-div">(Per Boat)</div>
          <div className="mt-2"> ₹ {parseInt(parseFloat(boat.ECBoatTotalCharge || 0) + parseFloat(boat.ECdepositeCharge || 0))}</div>
          <div className="boaatcharge ">
            {" "}
            <table>
              {boat.ECdepositeCharge != "0.00" ? (
                <tr>
                  <td>Boat</td>
                  <td>:</td>
                  <td> ₹ {parseInt(boat.ECBoatTotalCharge || 0)}</td>
                </tr>
              ) : (
                ""
              )}
              {boat.ECdepositeCharge != "0.00" ? (
                <tr>
                  <td>
                    <Popover
                      content={
                        <>
                          Charge includes Refundable Deposit of ₹ <b>{parseInt(boat.ECdepositeCharge || 0)}</b>
                        </>
                      }
                    >
                      <span className="depspan">Deposit</span>
                    </Popover>
                  </td>
                  <td>:</td>
                  <td> ₹ {parseInt(boat.ECdepositeCharge || 0)}</td>
                </tr>
              ) : (
                ""
              )}
            </table>
          </div>
          {console.log(this.context.state.type)}
          {this.context.state.type === "P" && this.context.state.selectedid.some((boatcart) => boatcart.boatid === boat.boatid) ? (
            <div className="" onClick={() => this.context.HideTimeSlot(boat, "P")}>
              <Button className={(boat.Normal === "Y" && (boat.Individual === "N"|| boat.Individual === "" || boat.Individual === null || boat.Individual === undefined ) && (boat.Express === "N" || boat.Express === "" || boat.Express === null || boat.Express === undefined)) ? "btn  btn-sm exbtn-new  btn-primary" : "btn  btn-sm exbtn  btn-primary"}>Hide Time Slot</Button>
            </div>
          ) : (
            <div className="" 
                  onClick={() => this.context.SelectTimeSlot(boat, "P")}

                // onClick={() => this.handleButtonClick(boat,"P")}
            >
              <Button className={(boat.Normal === "Y" && (boat.Individual === "N"|| boat.Individual === "" || boat.Individual === null || boat.Individual === undefined ) && (boat.Express === "N" || boat.Express === "" || boat.Express === null || boat.Express === undefined)) ? "btn  btn-sm exbtn-new  btn-primary" : "btn  btn-sm exbtn  btn-primary"}>Select Time Slot</Button>
            </div>
          )}
          {this.context.state.type === "P" && this.context.state.selectedid.some((boatcart) => boatcart.boatid === boat.boatid) && <div className={(boat.Normal === "Y" && (boat.Individual === "N"|| boat.Individual === "" || boat.Individual === null || boat.Individual === undefined ) && (boat.Express === "N" || boat.Express === "" || boat.Express === null || boat.Express === undefined)) ? "rectangle-new" : "rectangle"}></div>}
        </>
      </Col>
    );
  };
  

  render() {

    let STNEboatdata = [...this.context.state.boatCart, ...this.context.state.ticketCart, ...this.context.state.ExpressboatCart];
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 8,
      slidesToScroll: 1
    };
    const settingsE = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 8,
      slidesToScroll: 1
    };
    const settingsT = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 8,
      slidesToScroll: 1
    };
 
 
    return (
      <>
        {console.log("dhana check",this.props.boatdata)}
        {this.props.boatdata?.map((boat) => {
          return (
            <div fluid className="card-list"> 
              <Row className="hotel_wrap marker">
                <Col md={12} >
                  <Row>

                    <Col  >

                      <div className="imgdtls" style={{display:'flex',alignItems:'flex-start', flexDirection:'row'}}>

                        <div>
                          <img className="imagenotfound" onError={this.showErrorImg} src={boat.BoatImageLink} alt="Image Not Found" />
                        </div>

                        <div className="revwndname"> 
                          <div className="imgtitdiv">
                            <h5 class="ho_title mb-2 text-uppercase ">
                              {boat.BoatType} {boat.SeaterType}{" "} 
                              
                            </h5>
                            <div className="ml-3 vertical1 mt-1 "></div>
                            <div className="imgtitdiv1 mt-1 ml-2 mb-2">
                              <div>Duration : {boat.BoatMinTime} mins</div>
                              <div className="ml-2 vertical1 mr-2"></div>
                              {!boat?.BoatType?.includes("Pedal") ? 
                                <div>
                                  No of Persons :{" "}
                                  <Popover
                                    content={<div>
                                      The boat capacity is {boat.NoOfSeats} pax.
                                      Single person can avail the boat by paying full amount for riding independently <br /> (OR) he can avail the boat on sharing basis by paying per ticket cost
                                    </div>

                                    }
                                  >
                                    <span>{boat.NoOfSeats}&nbsp;</span>
                                    <span className="text-primary max-line">
                                      Max <BsFillInfoCircleFill size={10} />
                                    </span>
                                  </Popover>
                                </div>
                                :
                                <div>
                                  No of Persons :{" "}  
                                  <span>{boat.NoOfSeats}&nbsp;</span>
                                </div>
                              }
                              
                            </div>
                          </div> 
                          
                          <div>
                          {(boat.NoOfRatings != "" || boat.NoOfRatings != 0) && 
                            <Col md={3} className="reviewmaster">

                              <div className="reviewdiv justify-content-end">
                                <div className="ratflex ">
                                  {/* <i class="fa fa-star staricondiv" aria-hidden="true"></i>
                                  <i class="fa fa-star staricondiv" aria-hidden="true"></i>
                                  <i class="fa fa-star staricondiv" aria-hidden="true"></i>
                                  <i class="fa fa-star staricondiv" aria-hidden="true"></i>
                                  <i class="fa fa-star staricondiv" aria-hidden="true"></i> */}
                                  <ReactStars
                                    count={5}
                                    // onChange={ratingChanged}
                                    classNames="rstartdiv"
                                    value={boat.NoOfRatings}
                                    size={20}
                                    isHalf={true}
                                    emptyIcon={<i className="far fa-star"></i>}
                                    halfIcon={<i className="fa fa-star-half-alt"></i>}
                                    fullIcon={<i className="fa fa-star"></i>}
                                    activeColor="#ffd700"
                                  />
                                  <span classNmae="ml-4 mr-2 "> {boat.NoOfRatings} Reviews</span>
                                  <Reviews reviewDetails={boat} />

                                  {/* <Reviews reviewDetails={{ Rating: 4 }} boatdetails={boat}/> */}
                                  {/* <span className="rlinkdiv ml-2">Read more</span> */}
                                </div>
                              </div>
                            </Col>
                          }
                          </div>
                        </div>

                      </div>
                    </Col>
               
                  </Row>
                  
                  <Row style={{display:'flex',columnGap:'1rem', padding:'0rem 0.8rem'}}>
                    <Col md={3} className={"carouselcol newclass pl-1"}>
                      <>
                        {/* {boat.PremiumStatus == "P" && (
                          <div class="ribbon">
                            <span>Express</span>
                          </div>
                        )} */}
                        <div class="boatimgdiv">
                          <div>
                            <img className="imagenotfound" onError={this.showErrorImg} src={boat.BoatImageLink} alt="Image Not Found" />
                          </div>
                        </div>
                      </>
                    </Col>

                    <Col md={2} className="com_details">
                      <Row className=" stsow">
                        {STNEboatdata.some((boatcart) => boatcart.boatid == boat.boatid) &&
                         <div className={(boat.Normal === "Y" && (boat.Individual === "N"|| boat.Individual === "" || boat.Individual === null || boat.Individual === undefined ) && (boat.Express === "N" || boat.Express === "" || boat.Express === null || boat.Express === undefined)) ? "tsdiv-new mb-1" : "tsdiv mb-1"}>Selected Time Slot(s)</div>}

                        {this.context.state.ticketCart.some((boatcart) => boatcart.boatid == boat.boatid) && this.context.state.ticketCart.length != 0 && (
                          <>
                            {this.context.state.ticketCart.map(
                              (data, index) =>
                                data.boatid == boat.boatid && (
                                  <>
                                    {Array.from(Array(data.count), (e, i) => {
                                      return (
                                        <Col sm={1} className="selectedticketslotcol" >
                                            <div className="crossicon" onClick={() => this.context.removeticketdata(data, boat)}>
                                            {/* <TiDeleteOutline size={20} color="red" /> */}
                                            <IoMdClose size={18} color="red"/>
                                            </div>
                                            <div>
                                              {data.Timeslot.SlotStartTime}
                                              {/* to {data.Timeslot.SlotEndTime} */}
                                            </div>
                                          </Col>
                                          // <Col sm={1} className="selectedticketslotcol">
                                          //   <div className="crossicon" onClick={() => this.context.removeticketdata(data, boat)}>
                                          //     <TiDeleteOutline size={20} color="red" />
                                          //   </div>
                                          //   <div>
                                          //     {data.Timeslot.SlotStartTime}
                                              
                                          //   </div>
                                          // </Col> 
                                      );
                                    })}
                                  </>
                                )
                            )}
                          </>
                        )}

                        {this.context.state.boatCart.some((boatcart) => boatcart.boatid == boat.boatid) && this.context.state.boatCart.length != 0 && (
                          <>
                            {this.context.state.boatCart.map(
                              (data, index) =>
                                data.boatid == boat.boatid && (
                                  <>
                                    {Array.from(Array(data.count), (e, i) => {
                                      return (
 
                                        <Col sm={2} className="selectedslotcol">

                                         <div>
                                            {data.Timeslot.SlotStartTime} 
                                            {/* to {data.Timeslot.SlotEndTime} */}
                                          </div>

                                          <div className="crossicon" onClick={() => this.context.removeboatdata(data, boat)}>
                                            {/* <TiDeleteOutline size={20} color="red" /> */}
                                            <IoMdClose size={18} color="red"/>

                                          </div>
                                        
                                        </Col> 
                                      );
                                    })}
                                  </>
                                )
                            )}
                          </>
                        )}
                        {this.context.state.ExpressboatCart.some((boatcart) => boatcart.boatid == boat.boatid) && this.context.state.ExpressboatCart.length != 0 && (
                          <>
                            {this.context.state.ExpressboatCart.map(
                              (data, index) =>
                                data.boatid == boat.boatid && (
                                  <>
                                    {Array.from(Array(data.count), (e, i) => {
                                      return (
                                        <Col sm={2}  className={(boat.Normal === "Y" && (boat.Individual === "N"|| boat.Individual === "" || boat.Individual === null || boat.Individual === undefined ) && (boat.Express === "N" || boat.Express === "" || boat.Express === null || boat.Express === undefined)) ? "selectedexpressslotcol-new" : "selectedexpressslotcol"}
                                        >
                                          
                                          <div>
                                            {data.Timeslot.SlotStartTime} 
                                            {/* to {data.Timeslot.SlotEndTime} */}
                                          </div>

                                          <div className="crossicon" onClick={() => this.context.removeExpressdata(data, boat)}>
                                            {/* <TiDeleteOutline size={20} color="red" /> */}
                                            <IoMdClose size={18} color="red"/>
                                          </div>
                                        </Col>
                                      );
                                    })}
                                  </>
                                )
                            )}
                          </>
                        )}
                      </Row>
                    </Col>
                    {boat.Individual === "Y" && (
                      <>
                        {this.getNormalTicket(boat, "I")}

                        {/* </Col> */}
                      </>
                    )}
                    {boat.Normal === "Y" && (
                      <>
                        {this.getNormalBoat(boat, "N")}
                        {/* </Col> */}
                      </>
                    )}
                    {boat.Express === "Y" && (
                      <>
                        {this.getExpressBoat(boat, "P")}
                      </>
                    )}
                    
                    {this.context.state.type == "I" && this.context.state.selectedid.some((boatcart) => boatcart.boatid == boat.boatid) && (
                      <div className={ (boat.Normal === "Y" && (boat.Individual === "N"|| boat.Individual === "" || boat.Individual === null || boat.Individual === undefined ) && (boat.Express === "N" || boat.Express === "" || boat.Express === null || boat.Express === undefined)) ? "slotdivall-new mt-3" : "slotdivall mt-3"}>
                        <div className="ticketslot"> Normal Boat (Per Ticket) - Available Time Slots</div>
                          <Slider {...settingsT}> 
                            {this.context.state.TicketTime.length > 0 ? (
                              this.context.state.TicketTime.map((time, index) => (
                                <Skeleton active loading={this.context.state.isTimeLoading}>
                                <div className="ticketslotcol" id={time.SlotId} onClick={() => this.context.TicketTimeSlotClick(time, boat, "I")}>
                                  <div>
                                    {time.SlotStartTime} 
                                    {/* to {time.SlotEndTime} */}
                                  </div>
                                  <div className="tripdiv">Avl. trip(s) : <span className={ (boat.Normal === "Y" && (boat.Individual === "N"|| boat.Individual === "" || boat.Individual === null || boat.Individual === undefined ) && (boat.Express === "N" || boat.Express === "" || boat.Express === null || boat.Express === undefined)) ? "tripcountspan-new" : "tripcountspan"}>{time.AvailableTripCount}</span></div>
                                </div>
                                </Skeleton>
                              ))
                            ) : (
                              <div>
                                    <Skeleton active loading={this.context.state.isTimeLoading}>
                                <div className="noslots"> Slots are not available </div>
                                </Skeleton>
                              </div>
                            )}
                               </Slider> 
                          
                        
                      </div>
                    )}
                    {this.context.state.type == "N" && this.context.state.selectedid.some((boatcart) => boatcart.boatid == boat.boatid) && (
                      <div className={ (boat.Normal === "Y" && (boat.Individual === "N"|| boat.Individual === "" || boat.Individual === null || boat.Individual === undefined ) && (boat.Express === "N" || boat.Express === "" || boat.Express === null || boat.Express === undefined)) ? "slotdivall-new mt-3" : "slotdivall mt-3"}>
                        <div className={ (boat.Normal === "Y" && (boat.Individual === "N"|| boat.Individual === "" || boat.Individual === null || boat.Individual === undefined ) && (boat.Express === "N" || boat.Express === "" || boat.Express === null || boat.Express === undefined)) ? "slotname-new" : "slotname"}>{this.props.IsBoathouse ? "Normal Boat (Per Boat) - Available Time Slots" : "Booking (Per Slot) - Available Time Slots"} </div>



                        {/* <Slider ref={(c) => (this.slider = c)} {...settings}> */}
                        <Slider  {...settings}>

                          {this.context.state.NormalBoatTime.length > 0 ? (
                            this.context.state.NormalBoatTime.map((time, index) => (
                              <Skeleton active loading={this.context.state.isTimeLoading}>

                                <div className={ (boat.Normal === "Y" && (boat.Individual === "N"|| boat.Individual === "" || boat.Individual === null || boat.Individual === undefined ) && (boat.Express === "N" || boat.Express === "" || boat.Express === null || boat.Express === undefined)) ? "slotcol-new" : "slotcol"} id={time.SlotId} onClick={() => this.context.NormalTimeSlotClick(time, boat, "N")}>
                                  <div>
                                    {time.SlotStartTime} 
                                    {/* to {time.SlotEndTime} */}
                                  </div>
                                  <div className="tripdiv">Avl. trip(s) : <span className={ (boat.Normal === "Y" && (boat.Individual === "N"|| boat.Individual === "" || boat.Individual === null || boat.Individual === undefined ) && (boat.Express === "N" || boat.Express === "" || boat.Express === null || boat.Express === undefined)) ? "tripcountspan-new" : "tripcountspan"}>{time.AvailableTripCount}</span></div>
                                </div>
                              </Skeleton>
                            ))) : (
                            <div>
                              <Skeleton active loading={this.context.state.isTimeLoading}>
                                <div className="noslots"> Slots are not available </div>
                              </Skeleton>
                            </div>
                          )}



                        </Slider>




                        

                      </div>
                    )}
                    {/* {boat.Express === "Y" && (
                      <>
                        {this.getExpressBoat(boat, "P")}
                      </>
                    )} */}
                    {this.context.state.type == "P" && this.context.state.selectedid.some((boatcart) => boatcart.boatid == boat.boatid) && (
                      <div className={ (boat.Normal === "Y" && (boat.Individual === "N"|| boat.Individual === "" || boat.Individual === null || boat.Individual === undefined ) && (boat.Express === "N" || boat.Express === "" || boat.Express === null || boat.Express === undefined)) ? "slotdivall-new mt-3" : "slotdivall mt-3"}>
                        <div className=" expslot"> Express Boat (Per Boat) - Available Time Slots</div>
                        {/* <a className="prev" onClick={this.scroll.bind(null, -1)}>&#10094;</a>   <div className="image-container">
                          <Row className="rowscroll"> */}

                        {/* <Slider ref={(c) => (this.sliderE = c)} {...settingsE}> */}
                           <Slider {...settingsE}> 
                          {this.context.state.ExpressBoatTime.length > 0 ? (
                            this.context.state.ExpressBoatTime.map((time, index) => (
                              <Skeleton active loading={this.context.state.isTimeLoading} >
                                <div className="expressslotcolstyle" id={time.SlotId} onClick={() => this.context.ExpressTimeSlotClick(time, boat, "P")}>
                                  <div>
                                    {time.SlotStartTime} 
                                    {/* to {time.SlotEndTime} */}
                                  </div>
                                  <div className="tripdiv">Avl. trip(s) : <span className={ (boat.Normal === "Y" && (boat.Individual === "N"|| boat.Individual === "" || boat.Individual === null || boat.Individual === undefined ) && (boat.Express === "N" || boat.Express === "" || boat.Express === null || boat.Express === undefined)) ? "tripcountspan-new" : "tripcountspan"}>{time.AvailableTripCount}</span></div>
                                </div>
                              </Skeleton>
                            ))
                          ) : (
                            <div>
                              <Skeleton active loading={this.context.state.isTimeLoading} >
                                <div className="noslots"> Slots are not available </div>
                              </Skeleton>
                            </div>
                          )}
                        </Slider>

                        {/* </Row> */}
                        {/* </div> */}
                        {/* // <a className="next" onClick={this.scroll.bind(null, 1)}>&#10095;</a> */}
                      </div>
                    )}
                  </Row>
                </Col>
              </Row>
              {/* <Modal 
                  footer={false} 
                  title="Number of Persons Count" 
                  wrapClassName="Count__Modal" visible={this.state.openPersonAlert} 
                  closable={false}
              >
                    <div>
                    <Form getApi={this.setFormApi} onSubmit={this.handleSubmit}>
                          {this.context.state.EntranceList?.map((item, index) => (
                            <Input 
                              key={index}
                              field={item.ServiceName}
                              label={`Number of ${item.ServiceName}`}
                            />
                          ))}
                          {this.state.showErrorMsg && <p style={{color:"red"}}>{this.context.state.EntranceList?.length == 1 ? "Enter Number of Adult" :"Sorry !! No Child can travel without Adult."}</p>}
                          <button type="submit" className="btn btn-info mr-3" style={{ backgroundColor: "#28a745", border: "none", color: "white", fontWeight: "600" }}>
                                Submit
                          </button>
                    </Form>
                    

                    </div>
              </Modal> */}
            </div>
          );
        })}
      </>
    );
  }
}


export default BoatListCard;


